import React from 'react'
import { connect } from 'react-redux'

import NotLoggedIn from 'pages/NotLoggedIn'
import { getIsLoggedIn } from 'selectors/authSelectors'
import { isPaymentIQView } from 'selectors/appStatusSelectors'
import { isAuthRoute } from 'selectors/pageStateSelectors'

import './Footer.scss'

export function Footer({ showLogin }) {
  return (
    <div className="app-footer">
      <p>{showLogin ? <NotLoggedIn /> : null}</p>

      <p>
        <span className="iq-logo">
          illumi<span>QUOTE</span>
        </span>{' '}
        is powered by{' '}
        <a
          href="https://www.frikintech.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="ft-logo">
            <span>FRIKTIONLESS</span>technologies
          </span>
        </a>
      </p>
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    showLogin:
      !getIsLoggedIn(state) && !isPaymentIQView(state) && !isAuthRoute(state),
  }
}

export default connect(mapStateToProps)(Footer)
